.CircleBadge {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bgColor-default);
  border-radius: 50%;
  box-shadow: var(--shadow-resting-medium);

  &:where([data-inline]) {
    display: inline-flex;
  }
}

.CircleBadgeIcon {
  height: auto;
  max-height: 55%;
  max-width: 60%;
}
